export default "__VITE_ASSET__CA947pYv__"